//@flow
// Externals
import React, { useState } from "react";

// Styles
// $FlowFixMe
import "./SelectBox.scss";

// const SELECT_SUBMIT_TIME = 2000;

/*::
type Props = {
	value: string,
	placeholder: string,
	setStateValue: function,
	questionNumber: string,
	options: any
}
*/

// Select Box input component
const SelectBox = (props /*: Props */) /*: any */ => {
	const [showOptions, toggleShowOptions] = useState(false);
	const handleOptionClick = (item) => {
		if (item !== "Please select") {
			toggleShowOptions(false);
			props.setStateValue(item);
		} else {
		}
	};

	// handle click to open/hide select box
	const handleClick = (e) => {
		e.preventDefault();
		toggleShowOptions((show) => !show);
	};

	// not called?
	const handleSelectChange = (e) => {};

	return (
		<div className="select-box-wrapper">
			<div
				className={`select-box ${
					showOptions ? "select-box-open" : "select-box-closed"
				}`}
			>
				<select
					className="select-box"
					value={props.value}
					onMouseDown={handleClick}
					onChange={handleSelectChange}
					data-cy={"select-q" + props.questionNumber}
				>
					{!props.value && (
						<option data-cy="placeholder">
							{props.placeholder}
						</option>
					)}
					{props.options.map((item, index) => (
						<option key={index} value={props.options[index]}>
							{props.options[index]}
						</option>
					))}
				</select>
				{showOptions && (
					<div className="">
						<div className="select-options-container">
							{props.options.map((item) => (
								<div
									data-cy={"option-" + item}
									className={
										"option" +
										(item === props.value
											? " selected"
											: "")
									}
									onClick={() => handleOptionClick(item)}
									key={item}
								>
									{item}
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

// Exports
export default SelectBox;
